"use strict";

var _classCallCheck = require("/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NodeHttpClientResponse = exports.NodeHttpClient = void 0;
var http_ = require("http");
var https_ = require("https");
var HttpClient_js_1 = require("./HttpClient.js");
// `import * as http_ from 'http'` creates a "Module Namespace Exotic Object"
// which is immune to monkey-patching, whereas http_.default (in an ES Module context)
// will resolve to the same thing as require('http'), which is
// monkey-patchable. We care about this because users in their test
// suites might be using a library like "nock" which relies on the ability
// to monkey-patch and intercept calls to http.request.
var http = http_.default || http_;
var https = https_.default || https_;
var defaultHttpAgent = new http.Agent({
  keepAlive: true
});
var defaultHttpsAgent = new https.Agent({
  keepAlive: true
});
/**
 * HTTP client which uses the Node `http` and `https` packages to issue
 * requests.`
 */
var NodeHttpClient = /*#__PURE__*/function (_HttpClient_js_1$Http) {
  _inherits(NodeHttpClient, _HttpClient_js_1$Http);
  function NodeHttpClient(agent) {
    var _this;
    _classCallCheck(this, NodeHttpClient);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(NodeHttpClient).call(this));
    _this._agent = agent;
    return _this;
  }
  /** @override. */
  _createClass(NodeHttpClient, [{
    key: "getClientName",
    value: function getClientName() {
      return 'node';
    }
  }, {
    key: "makeRequest",
    value: function makeRequest(host, port, path, method, headers, requestData, protocol, timeout) {
      var isInsecureConnection = protocol === 'http';
      var agent = this._agent;
      if (!agent) {
        agent = isInsecureConnection ? defaultHttpAgent : defaultHttpsAgent;
      }
      var requestPromise = new Promise(function (resolve, reject) {
        var req = (isInsecureConnection ? http : https).request({
          host: host,
          port: port,
          path: path,
          method: method,
          agent: agent,
          headers: headers,
          ciphers: 'DEFAULT:!aNULL:!eNULL:!LOW:!EXPORT:!SSLv2:!MD5'
        });
        req.setTimeout(timeout, function () {
          req.destroy(HttpClient_js_1.HttpClient.makeTimeoutError());
        });
        req.on('response', function (res) {
          resolve(new NodeHttpClientResponse(res));
        });
        req.on('error', function (error) {
          reject(error);
        });
        req.once('socket', function (socket) {
          if (socket.connecting) {
            socket.once(isInsecureConnection ? 'connect' : 'secureConnect', function () {
              // Send payload; we're safe:
              req.write(requestData);
              req.end();
            });
          } else {
            // we're already connected
            req.write(requestData);
            req.end();
          }
        });
      });
      return requestPromise;
    }
  }]);
  return NodeHttpClient;
}(HttpClient_js_1.HttpClient);
exports.NodeHttpClient = NodeHttpClient;
var NodeHttpClientResponse = /*#__PURE__*/function (_HttpClient_js_1$Http2) {
  _inherits(NodeHttpClientResponse, _HttpClient_js_1$Http2);
  function NodeHttpClientResponse(res) {
    var _this2;
    _classCallCheck(this, NodeHttpClientResponse);
    // @ts-ignore
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(NodeHttpClientResponse).call(this, res.statusCode, res.headers || {}));
    _this2._res = res;
    return _this2;
  }
  _createClass(NodeHttpClientResponse, [{
    key: "getRawResponse",
    value: function getRawResponse() {
      return this._res;
    }
  }, {
    key: "toStream",
    value: function toStream(streamCompleteCallback) {
      // The raw response is itself the stream, so we just return that. To be
      // backwards compatible, we should invoke the streamCompleteCallback only
      // once the stream has been fully consumed.
      this._res.once('end', function () {
        return streamCompleteCallback();
      });
      return this._res;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        var response = '';
        _this3._res.setEncoding('utf8');
        _this3._res.on('data', function (chunk) {
          response += chunk;
        });
        _this3._res.once('end', function () {
          try {
            resolve(JSON.parse(response));
          } catch (e) {
            reject(e);
          }
        });
      });
    }
  }]);
  return NodeHttpClientResponse;
}(HttpClient_js_1.HttpClientResponse);
exports.NodeHttpClientResponse = NodeHttpClientResponse;